module.exports = __webpack_public_path__ + "img/banner_pay.e74afa71.png";